import { Contact } from '@amzn/awscat-portfolio-assessment-types';

import { constants } from '../../../common/Localization';
import { ColumnDefinition, ColumnTypes } from '../../../common/table/types';

export const getContactsTableColumnDefinitions: ColumnDefinition<Contact>[] = [
    {
        id: 'name',
        header: constants.NAME,
        type: ColumnTypes.TEXT,
        cell: item => item.name,
    },
    {
        id: 'email',
        header: constants.EMAIL,
        type: ColumnTypes.TEXT,
        cell: item => item.email,
    },
    {
        id: 'phone',
        header: constants.PHONE,
        type: ColumnTypes.TEXT,
        cell: item => item.phone,
    }
];

export type ContactActions = 'add' | 'edit';
